/**
 * Проверяет является ли переданное значение числом.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является числом, иначе false.
 * @example
 * ```typescript
 * import { isNumber } from '@direct-frontend/stdlib';
 *
 * isNumber(1); // true
 * isNumber('1'); // false
 * ```
 */
export function isNumber(value) {
    return typeof value === 'number';
}
